import { useRef } from 'react'

const defaultComparator = (a: unknown, b: unknown) => a === b

/**
 * This hook keeps the reference to the array of items, if items in the array were not updated
 */
export const useStaticArray = <T>(
  items: T[],
  compare: (a: T, b: T) => boolean = defaultComparator,
) => {
  const itemsRef = useRef(items)

  // Same reference
  if (items === itemsRef.current) {
    return items
  }

  // Different length or different items
  if (
    itemsRef.current.length !== items.length ||
    !itemsRef.current.every((item, index) => compare(item, items[index]))
  ) {
    itemsRef.current = items
  }

  return itemsRef.current
}
